module.exports = __webpack_public_path__ + "static/assets/2d21f8a3243d8af9054c520000e19d49.svg";